import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  OnDestroy,
  EventEmitter,
  Output,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {
  IQuizBlockDTO,
  QuizBlockDTO,
} from '@app/infrastructure/models/quiz-block';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-quiz-answer',
  templateUrl: './quiz-answer.component.html',
  styleUrls: ['./quiz-answer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuizAnswerComponent implements OnInit, OnDestroy {
  @Input() form: UntypedFormGroup = new UntypedFormGroup({});
  @Input() quiz: QuizBlockDTO = new QuizBlockDTO();
  @Output() answerUpdatedEmitter: EventEmitter<QuizBlockDTO> =
    new EventEmitter();
  private subscriptions: Subscription[] = [];
  constructor() {}

  ngOnInit(): void {
    this.form.addControl(
      'freeanswer',
      new UntypedFormControl(this.quiz.text || ''),
    );
    const sub = this.form.valueChanges
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((value) => {
        this.quiz.text = value.freeanswer;
        this.answerUpdatedEmitter.emit(this.quiz);
      });
    this.subscriptions.push(sub);
  }

  ngOnDestroy(): void {
    this.form.removeControl('freeanswer');
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  public get stepForm() {
    return this.form?.get('freeanswer')?.value;
  }
}
